export default "__VITE_ASSET__BeZoPg6h__"